module.exports = __webpack_public_path__ + "img/快捷实施.227d81a3.svg";